import { Menus } from '@/models'

export default {
    getMenus (state: { menu: Array<Menus> }) {
        return state.menu
    }
}
